import styled from 'styled-components';

const Container = styled.div`
  margin: 0 auto;
  width: ${(props) => props.theme.spacing.wrapWidth}px;
`;

export default Container;
